import { render, staticRenderFns } from "./Order_mobile.vue?vue&type=template&id=77c4b6f6&scoped=true&"
import script from "./Order_mobile.vue?vue&type=script&lang=js&"
export * from "./Order_mobile.vue?vue&type=script&lang=js&"
import style0 from "./Order_mobile.vue?vue&type=style&index=0&id=77c4b6f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77c4b6f6",
  null
  
)

export default component.exports